// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { SubscriptionRoutes } from "..";
import { ThemeProvider } from "@emotion/react";
import styled from "@emotion/styled";
import * as React from "react";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { Dispatch } from "redux";

import { Button, Modal, TextArea } from "@livechat/design-system";

import sadEarlSrc from "assets/svg/earl-sad.svg";
import LinkButton from "components/button/LinkButton";
import { BackButton, ViewContainer } from "components/grid";
import { IStoreState } from "interfaces/storeState";
import { SubscriptionActions, selectIsCancelingSubscription } from "store/entities/subscriptions";
import { legacyTheme } from "themes/legacyTheme";

import { ButtonsWrapper, ContentBox, ContentBoxWrapper } from "../styled";

interface IDispatchProps {
  onCancel(): void;
}

interface IStateProps {
  isCancelingSubscription: boolean;
}

interface IProps extends IDispatchProps, IStateProps, RouteComponentProps {}

interface IState {
  showCancelModal: boolean;
  feedback: string;
}

const StyledImg = styled.img`
  display: block;
  height: 54px;
  margin: 0 auto 20px;
`;

class SubscriptionCancel extends React.PureComponent<IProps, IState> {
  state = {
    showCancelModal: false,
    feedback: "",
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  handleCancelAccountClick = () => {
    this.props.onCancel();
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  handleModalClose = () => {
    this.setState({
      showCancelModal: false,
    });
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  handleFeedbackChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    this.setState({
      feedback: e.currentTarget.value,
    });
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  render() {
    const { history, isCancelingSubscription } = this.props;
    const { feedback, showCancelModal } = this.state;
    const feedbackIsEmpty = feedback.length === 0;
    const backButton = <BackButton onClick={() => history.push(SubscriptionRoutes.AccountDetails)}>Back</BackButton>;

    return (
      <>
        <ThemeProvider theme={legacyTheme}>
          <ViewContainer title="Cancel account" stackShowBackButton backButton={backButton} placement="main-content">
            <ContentBoxWrapper>
              <ContentBox centered>
                <StyledImg src={sadEarlSrc} />
                <h1>We’re sorry to see you leave…</h1>
                <p>
                  Could you tell us what went wrong?
                  <br />
                  That way, we might meet again.
                </p>
                <TextArea placeholder="What went wrong?" value={feedback} onChange={this.handleFeedbackChange} />
                <ButtonsWrapper>
                  <LinkButton to={SubscriptionRoutes.AccountDetails} size="large" disabled={isCancelingSubscription}>
                    Dismiss
                  </LinkButton>
                  <Button
                    kind="destructive"
                    size="large"
                    onClick={this.handleCancelAccountClick}
                    disabled={feedbackIsEmpty || isCancelingSubscription}
                  >
                    {isCancelingSubscription ? "Canceling…" : "Cancel account"}
                  </Button>
                </ButtonsWrapper>
              </ContentBox>
            </ContentBoxWrapper>
          </ViewContainer>
        </ThemeProvider>
        {showCancelModal && (
          <Modal
            heading="Account canceling confirmation"
            footer={
              <>
                <Button onClick={this.handleModalClose}>Dismiss</Button>
                <Button kind="primary" onClick={this.handleModalClose}>
                  Dismiss
                </Button>
              </>
            }
            onClose={this.handleModalClose}
          >
            <>
              In progress…
              {/*
              <p>
                To confirm canceling your account, please type your password.
                <br />
                <strong>This action cannot be undone.</strong> Are you sure you want to continue?
              </p>
              <StyledInput type="password" />
                */}
            </>
          </Modal>
        )}
      </>
    );
  }
}

const mapStateToProps = (state: IStoreState): IStateProps => ({
  isCancelingSubscription: selectIsCancelingSubscription(state),
});

const mapDispatchToProps = (dispatch: Dispatch): IDispatchProps => ({
  // @ts-expect-error TS(2345)
  onCancel: () => dispatch(SubscriptionActions.delete({})),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SubscriptionCancel));
